<template>
  <div class="share-node-list">
    <div v-if="!list.length" class="empty-text">暂无物流节点</div>
    <div
      v-for="(item, index) in list"
      :key="`${item.nodeCode || 'node'}-${item.nodeTime || index}`"
      class="node-item"
    >
      <div class="timeline">
        <span class="dot"></span>
        <span v-if="index !== list.length - 1" class="line"></span>
      </div>
      <div class="node-content">
        <div class="node-name">{{ item.nodeName || '--' }}</div>
        <div class="node-meta">
          <div class="operator">
            <svg xmlns="http://www.w3.org/2000/svg" class="operator-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#FFBD2D"/>
              <path d="M15.2137 13.333C15.1698 12.8762 14.9572 12.4521 14.6174 12.1435C14.2777 11.8349 13.8352 11.6639 13.3762 11.6639C12.9173 11.6639 12.4748 11.8349 12.1351 12.1435C11.7953 12.4521 11.5827 12.8762 11.5387 13.333H8.83874C8.79475 12.8762 8.58216 12.4521 8.24243 12.1435C7.9027 11.8349 7.46021 11.6639 7.00125 11.6639C6.54229 11.6639 6.0998 11.8349 5.76007 12.1435C5.42034 12.4521 5.20773 12.8762 5.16374 13.333H4.75175C4.54253 13.3201 4.34672 13.2256 4.20646 13.0698C4.06621 12.914 3.99271 12.7094 4.00175 12.5V10.417H12.2518V7.582C12.2495 7.44458 12.2803 7.30861 12.3416 7.18558C12.4028 7.06254 12.4927 6.95604 12.6037 6.875C12.7086 6.80051 12.8322 6.75696 12.9606 6.74936C13.089 6.74176 13.2169 6.7704 13.3297 6.832L15.5797 8.047C15.7107 8.12283 15.819 8.2324 15.8932 8.36432C15.9675 8.49624 16.0049 8.64566 16.0018 8.797V12.497C16.0108 12.7064 15.9373 12.911 15.797 13.0668C15.6568 13.2226 15.461 13.3171 15.2518 13.33L15.2137 13.333ZM4.75075 5H10.7507C10.96 5.01291 11.1558 5.1074 11.296 5.26318C11.4363 5.41896 11.5098 5.62359 11.5007 5.83301V9.58301H4.00075V5.83301C3.9917 5.62359 4.06522 5.41896 4.20547 5.26318C4.34573 5.1074 4.54153 5.01291 4.75075 5ZM7.00075 15C7.25359 15.0267 7.50858 14.9761 7.73207 14.8549C7.95556 14.7337 8.13702 14.5475 8.25253 14.321C8.36804 14.0945 8.41215 13.8383 8.37904 13.5862C8.34593 13.3342 8.23714 13.098 8.06706 12.9091C7.89698 12.7201 7.67359 12.5871 7.42637 12.5277C7.17916 12.4683 6.91976 12.4853 6.68239 12.5764C6.44502 12.6675 6.24084 12.8284 6.09683 13.038C5.95282 13.2475 5.87574 13.4958 5.87575 13.75C5.85994 14.0648 5.96941 14.373 6.18023 14.6072C6.39106 14.8415 6.68607 14.9827 7.00075 15ZM13.3757 15C13.6286 15.0267 13.8836 14.9761 14.1071 14.8549C14.3306 14.7337 14.512 14.5475 14.6275 14.321C14.743 14.0945 14.7872 13.8383 14.754 13.5862C14.7209 13.3342 14.6121 13.098 14.4421 12.9091C14.272 12.7201 14.0486 12.5871 13.8014 12.5277C13.5542 12.4683 13.2948 12.4853 13.0574 12.5764C12.82 12.6675 12.6158 12.8284 12.4718 13.038C12.3278 13.2475 12.2507 13.4958 12.2507 13.75C12.2349 14.0648 12.3444 14.373 12.5552 14.6072C12.7661 14.8415 13.0611 14.9827 13.3757 15Z" fill="white"/>
            </svg>
            <span>{{ item.feedbackPeople || '--' }}</span>
          </div>
          <span class="node-time">{{ item.nodeTime || '--' }}</span>
        </div>
        <div v-if="item.feedbackAddress || photos(item).length" class="feedback-card">
          <div v-if="item.feedbackAddress" class="feedback-address">
            {{ item.feedbackAddress }}
          </div>
          <div v-if="photos(item).length" class="photo-list">
            <van-image
              v-for="photo in photos(item)"
              :key="photo"
              width="75"
              height="75"
              fit="cover"
              class="feedback-photo"
              :src="photo"
              @click="preview(photos(item), photo)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage, ImagePreview, Toast } from 'vant';

export default {
  name: 'ShareOrderNodeList',
  components: {
    [VanImage.name]: VanImage
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 保存预览实例及对应的浏览器历史标识
      previewInstance: null,
      previewHistoryKey: null
    };
  },
  methods: {
    photos(item) {
      const value = item && item.feedbackPhoto;
      if (!value) return [];
      if (Array.isArray(value)) return value.filter(Boolean);
      return String(value).split(';').filter(Boolean);
    },
    preview(images, current) {
      if (!images.length) return Toast.fail('图片参数缺失');

      const historyKey = `${Date.now()}-${Math.random()}`;
      this.previewHistoryKey = historyKey;
      // 增加一条同页面历史，使 iOS 系统返回键优先关闭预览，而不是退出详情页
      window.history.pushState(
        Object.assign({}, window.history.state, {
          imagePreviewKey: historyKey
        }),
        '',
        window.location.href
      );

      this.previewInstance = ImagePreview({
        images,
        startPosition: Math.max(0, images.findIndex(item => item === current)),
        loop: false,
        closeOnPopstate: true,
        onClose: () => {
          const state = window.history.state || {};
          // 点击关闭按钮时主动移除预览历史；系统返回触发关闭时该历史已被移除
          if (state.imagePreviewKey === this.previewHistoryKey) {
            window.history.back();
          }
          this.previewInstance = null;
          this.previewHistoryKey = null;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.share-node-list {
  flex: 1;
  min-height: 0;
  max-height: 600px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  padding: 14px 28px 32px;
  background: #fff;
  color: #3d3833;
}
.empty-text {
  padding: 48px 0;
  color: #85807b;
  font-size: 14px;
  text-align: center;
}
.node-item {
  position: relative;
  display: flex;
  min-height: 128px;
}
.timeline {
  position: relative;
  flex: 0 0 34px;
}
.dot {
  position: absolute;
  top: 5px;
  left: 0;
  z-index: 2;
  width: 10px;
  height: 10px;
  box-sizing: border-box;
  border: 2px solid #ffbd2d;
  border-radius: 50%;
  background: #fff;
}
.line {
  position: absolute;
  top: 15px;
  bottom: 0;
  left: 4px;
  width: 1px;
  border-left: 1px dashed #ffbd2d;
}
.node-content {
  flex: 1;
  min-width: 0;
  padding-bottom: 36px;
}
.node-name {
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
}
.node-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 14px;
  line-height: 22px;
}
.operator {
  display: flex;
  align-items: center;
}
.operator-icon {
  margin-right: 8px;
}
.node-time {
  margin-left: 12px;
  white-space: nowrap;
}
.feedback-card {
  margin-top: 7px;
  padding: 10px 8px 8px;
  border-radius: 4px;
  background: #f8f8f8;
}
.feedback-address {
  font-size: 12px;
  line-height: 18px;
  text-align: justify;
}
.photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}
.feedback-photo {
  overflow: hidden;
  border-radius: 8px;
}
</style>
